export const consent = {
  brand: 'OVERHEAR',
  title: 'Consent form',
  subtitle: 'How OVERHEAR may use your story, voice and image',
  intro:
    'OVERHEAR collects and shares stories from communities. Your contribution may become part of an audio experience that people can listen to in the OVERHEAR app and through QR codes in public places.',
  whatIsThisForTitle: 'What is this for?',
  whatIsThisForStories:
    'OVERHEAR collects and shares stories from communities. This form asks for your permission to record, keep and share the story, poem or memory you contribute, and to take photographs or film if you agree.',
  whatIsThisForAudio:
    'Your contribution may become part of an audio experience that people can listen to in the OVERHEAR app and through QR codes in public places.',
  happenTitle: 'What will happen',
  happen: {
    record: 'We may record your voice in a workshop or session.',
    story: 'You might share a story, poem or memory.',
    transcribe: 'We will use a computer programme to type your words.',
    edit: 'We might edit your recording to make it clearer or shorter.',
    share: 'Your story may be shared on the OVERHEAR app or with QR codes.',
    archive: 'Your story may be kept in an archive so people in the future can hear it.',
  },
  rightsTitle: 'Your rights',
  rights: {
    refuse: 'You can say no or change your mind at any time.',
    remove: 'You can ask for your story to be removed.',
    copy: 'You can ask for a copy of your recording.',
    private: 'We will keep your information safe and private.',
  },
  contact: 'If you want to talk to us or change your consent, please email',
  contactEmail: 'hello@theoverhear.app',
  choicesTitle: 'Your choices',
  choicesIntro:
    'Please tick the boxes you agree with. You do not have to agree to everything.',
  agreeVoice: 'I agree for my voice to be recorded',
  agreeTyped: 'I agree for my recording to be typed and edited',
  stayAnonymous: 'I want to stay anonymous (my name will not be shared)',
  agreePhoto: 'I agree to have my picture taken as part of this work',
  agreeFilming: 'I agree to be filmed as part of this work',
  aboutYouTitle: 'About you',
  aboutYouWho:
    'Help us understand who is taking part. We will only use this information to help us learn about who is involved, not to identify you.',
  aboutYouCommunities: 'This helps us make sure that different people and communities are included.',
  aboutYouOptional:
    'You do not have to answer every question — only the ones you feel comfortable sharing.',
  nameLabel: 'Name',
  ageLabel: 'Age',
  genderLabel: 'Gender',
  postcodeLabel: 'Postcode',
  ethnicityLabel: 'Ethnicity',
  emailLabel: 'Email (optional)',
  emailHint: 'Needed only if you would like updates',
  parentGuardianLabel: 'Parent or guardian name',
  parentGuardianHint: 'Required if you are under 18',
  signatureLabel: 'Type your name as your signature',
  signatureHint: 'This is your electronic signature for this consent form.',
  dateLabel: 'Date',
  wantsUpdates: 'I would like to get updates from OVERHEAR',
  agreedToInformation:
    'I have read this information and I am happy for OVERHEAR to use my contribution as I have indicated above.',
  submit: 'Submit consent',
  submitting: 'Submitting…',
  submittedTitle: 'Thank you',
  submittedBody:
    'Your consent has been recorded. If you change your mind, email hello@theoverhear.app and we will update or remove it.',
  submitFailed: 'Could not send your consent form. Please try again.',
  validation: {
    nameRequired: 'Please enter your name.',
    signatureRequired: 'Please type your name as your signature.',
    parentRequired: 'Please enter a parent or guardian name if you are under 18.',
    emailRequired: 'Please enter an email address if you would like updates.',
    emailInvalid: 'Please enter a valid email address.',
    agreeRequired: 'Please confirm that you have read this information.',
  },
  adminPageTitle: 'Consent forms',
  adminPageSubtitle: 'Responses from the public consent form at /consent',
  adminEmpty: 'No consent forms yet.',
  adminName: 'Name',
  adminEmail: 'Email',
  adminAnonymous: 'Anonymous',
  adminSubmitted: 'Submitted',
  adminOpen: 'View',
  adminCopyLink: 'Copy public form link',
  adminYes: 'Yes',
  adminNo: 'No',
  adminChoices: 'Choices',
  adminAbout: 'About you',
  adminParentGuardian: 'Parent or guardian',
  adminSignature: 'Signature',
  adminWorkshop: 'Workshop',
  adminUnder18: 'Under 18',
  adminWantsUpdates: 'Updates',
};
